import { render, staticRenderFns } from "./RxSummaryCardPair.vue?vue&type=template&id=1026eb49&scoped=true&"
import script from "./RxSummaryCardPair.vue?vue&type=script&lang=js&"
export * from "./RxSummaryCardPair.vue?vue&type=script&lang=js&"
import style0 from "./RxSummaryCardPair.vue?vue&type=style&index=0&id=1026eb49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026eb49",
  null
  
)

export default component.exports